var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.096 23.4912C58.9925 24.3877 59.5005 25.6029 59.5005 26.868V41.1221C59.5005 42.3871 58.9925 43.6023 58.096 44.4988L44.5093 58.0955C43.6128 58.992 42.3976 59.5 41.1325 59.5H26.8784C25.6134 59.5 24.3981 58.992 23.5017 58.0955L9.90498 44.5088C9.0085 43.6123 8.50049 42.3971 8.50049 41.132V26.8779C8.50049 25.6129 9.0085 24.3977 9.90498 23.5012L23.4917 9.90449C24.3882 9.00801 25.6034 8.5 26.8685 8.5H41.1226C42.3876 8.5 43.6028 9.00801 44.4993 9.90449L58.096 23.4912ZM46.113 42.168C46.5812 41.6998 46.5812 40.9428 46.113 40.4746L39.6384 34L46.123 27.5154C46.5911 27.0473 46.5911 26.2902 46.123 25.8221L42.1685 21.8875C41.7003 21.4193 40.9433 21.4193 40.4751 21.8875L34.0005 28.3621L27.5159 21.8775C27.0478 21.4094 26.2907 21.4094 25.8226 21.8775L21.888 25.832C21.4198 26.3002 21.4198 27.0572 21.888 27.5254L28.3726 34.01L21.888 40.4945C21.4198 40.9627 21.4198 41.7197 21.888 42.1879L25.8325 46.1324C26.3007 46.6006 27.0577 46.6006 27.5259 46.1324L34.0105 39.6479L40.495 46.1324C40.9632 46.6006 41.7202 46.6006 42.1884 46.1324L46.113 42.168Z",
    fill: "black",
    fillOpacity: 0.2588
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.781e50a6.svg";
export { ForwardRef as ReactComponent };